export class CanvasProperties {
    canvasWidth = 0;
    canvasHeight = 0;
    scale = 1;
    zoomTranslateX = 0;
    zoomTranslateY = 0;
}
  